type UTCSwitchProps = {
  displayUTC: boolean;
  onClick: (displayUTC: boolean) => void;
};
const UTCSwitch = ({ displayUTC, onClick }: UTCSwitchProps) => {
  const onChangeUTC = () => {
    onClick(!displayUTC);
  };

  return (
    <div className="checkbox">
      <label>UTC:</label>
      <input type="checkbox" checked={displayUTC} onChange={onChangeUTC} />
    </div>
  );
};

export default UTCSwitch;
